import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { PATH } from '../../../../constants/path';
import { CONTEXT_ROOT } from '../../../../constants';

import { fetchAccountGains } from '../../../../services/account/gains/actions';
import { fetchPaymentRequestsIfNeeded } from '../../../../services/account/paymentrequest/ongoing/actions';

import { getWaitingAmount } from '../../../../services/account/gains/selector';
import { getValidatedAmount } from '../../../../services/account/gains/selector';
import { getOnGoingPaidAmount } from '../../../../services/account/paymentrequest/ongoing/selector';

import { plusAmount, minusAmount } from '../../../../utils/mathUtils';

import HeadComponent from '../../../HeadComponent';
import PaymentAreaComponent from './PaymentAreaComponent';
import ButtonComponent from '../../../button/ButtonComponent';
import ResumeCashbackComponent from './resume/ResumeCashbackComponent';
import CashbackHistoryComponent from './history/CashbackHistoryComponent';

import './AccountPurchase.scss';

export class AccountPurchasePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPaymentArea: false,
            showHistory: true
        };
    }

    componentDidMount() {
        const { fetchPaymentRequestsIfNeeded } = this.props;

        fetchPaymentRequestsIfNeeded();
    }

    showPaymentArea = () => {
        this.setState({
            showPaymentArea: true,
            showHistory: false
        });
    };
    showHistory = () => {
        this.setState({
            showPaymentArea: false,
            showHistory: true
        });
    };

    render() {
        const { i18nPage, validatedAmount, waitingAmount, paymentRequestTotalAmount } = this.props;
        const { showPaymentArea, showHistory } = this.state;

        const totalCashback = minusAmount(
            plusAmount(validatedAmount, waitingAmount),
            paymentRequestTotalAmount
        );
        const validatedMinusPaymentRequest = minusAmount(
            validatedAmount,
            paymentRequestTotalAmount
        );

        return (
            <div id="p-compte-cagnottecashback">
                <HeadComponent
                    title={i18nPage.TITLE}
                    description={i18nPage.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.ACCOUNT_JACKPOT_PATH}`}
                />

                <ResumeCashbackComponent
                    totalCashback={totalCashback}
                    leftAmount={validatedMinusPaymentRequest}
                    rightAmount={waitingAmount}
                />

                <div className="container-button">
                    <ButtonComponent
                        text={i18nPage.BUTTON_USE}
                        color="main"
                        cssClass={`payment ${!showPaymentArea ? 'reverse' : ''}`}
                        onClick={this.showPaymentArea}
                    />
                    <ButtonComponent
                        text={i18nPage.BUTTON_HISTORY}
                        color="main"
                        cssClass={`historic ${!showHistory ? 'reverse' : ''}`}
                        onClick={this.showHistory}
                    />
                </div>

                {showPaymentArea && <PaymentAreaComponent />}

                {showHistory && <CashbackHistoryComponent />}
            </div>
        );
    }
}

AccountPurchasePage.propTypes = {
    validatedAmount: PropTypes.number,
    waitingAmount: PropTypes.number,
    i18nPage: PropTypes.object.isRequired,
    fetchAccountGains: PropTypes.func.isRequired,
    fetchPaymentRequestsIfNeeded: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        validatedAmount: getValidatedAmount(state),
        waitingAmount: getWaitingAmount(state),
        paymentRequestTotalAmount: getOnGoingPaidAmount(state),
        i18nPage: state.i18n.page.ACCOUNT.CASHBACK
    };
}

const mapDispatchToProps = {
    fetchAccountGains,
    fetchPaymentRequestsIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountPurchasePage);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/AccountPurchasePage.js